import { render, staticRenderFns } from "./TaskDetailEmptyState.vue?vue&type=template&id=397578ab"
import script from "./TaskDetailEmptyState.vue?vue&type=script&lang=js"
export * from "./TaskDetailEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports